<script setup lang="ts">
import type { Token } from '@/references/tokens';

import TokenImage from '@/components/TokenImage.vue';

const props = defineProps<{
  from: Token;
  to: Token;
}>();
</script>

<template>
  <div class="token-image-compound">
    <TokenImage
      class="token-image-compound__image token-image-compound__image_bottom"
      :token="props.to"
      hide-network-icon
    />
    <TokenImage
      class="token-image-compound__image token-image-compound__image_top"
      :token="props.from"
      hide-network-icon
    />
    <img
      class="token-image-compound__overlay"
      src="@/assets/images/curl-mask-overlay@2x.png"
      alt=""
    />
  </div>
</template>

<style scoped>
.token-image-compound {
  --slope-offset: 5.5px;

  position: relative;
  width: 44px;
  height: 44px;
}

.token-image-compound__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.token-image-compound__image_top {
  clip-path: polygon(
    0 0,
    var(--slope-offset) 0,
    100% calc(100% - var(--slope-offset)),
    100% 100%,
    0 100%
  );
}

.token-image-compound__image_bottom {
  clip-path: polygon(var(--slope-offset) 0, 100% 0, 100% calc(100% - var(--slope-offset)));
}

.token-image-compound__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 44px;
  height: 44px;
}
</style>
